import { jsx as e } from "react/jsx-runtime";
import { S as w } from "../../icon-more-vertical-B44GwC0l.js";
import { useCallback as n } from "react";
import { Button as x } from "../../shared/button/Button.component.js";
import { ButtonShapeEnum as y, ButtonSizeEnum as B, ButtonThemeEnum as C } from "../../shared/button/types.js";
import { FileActionsDropdown as S } from "../FileActionsDropdown.component.js";
const E = ({
  copies: a,
  file: t,
  onDeleteEntry: p,
  onCopy: r,
  onDownload: s,
  onView: m
}) => {
  const c = n(() => {
    p(t);
  }, [t, p]), d = n(() => {
    r(t);
  }, [t, r]), u = n(async () => {
    s(t);
  }, [t, s]), i = n(() => {
    m(t);
  }, [t, m]), h = n(
    ({ close: o }) => /* @__PURE__ */ e(
      S,
      {
        copies: a,
        onClose: o,
        onDelete: c,
        onCopy: d,
        onDownload: u,
        onView: i
      }
    ),
    [a, d, c, u, i]
  ), l = n(
    ({ ref: o, onClick: b }) => /* @__PURE__ */ e(
      x,
      {
        theme: C.naked,
        size: B.md,
        shape: y.circle,
        className: "app:[--button--padding:0px] app:[--button--min-width--md:44px] app:aspect-square app:justify-end",
        onClick: b,
        disabled: !1,
        ref: o,
        type: "button",
        children: /* @__PURE__ */ e(w, { className: "app:w-6 app:h-6" })
      }
    ),
    []
  );
  return {
    renderMenuContent: h,
    renderbutton: l
  };
};
export {
  E as useFileAction
};
